import moment from 'moment';
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { AppBarNavigationItemPortalDestinationId } from '../../components/AppBar';
import { NavigationBreadcrumbsBar } from '../../components/NavigationBreadcrumbsBar';
import { Portal } from '../../components/Portal';
import { INavigationItemProps } from '../MainContainer';

export class BuildInfo extends React.Component<INavigationItemProps> {
	public componentDidMount() {
		fetch('/static/build-info.json')?.then(async res => {
			console.log(await res.json());
		});
	}

	public render() {
		return (
			<div className={css(s.root)}>
				<Portal destination={AppBarNavigationItemPortalDestinationId}>
					<NavigationBreadcrumbsBar currentLocationName='Build Info' />
				</Portal>
				<div>{`Date:\t${moment(__BUILD_TIME__).format('hh:mm:ss A\tMM/DD/YYYY')}`}</div>
				<div>{`Hash:\t${__BUILD_HASH__}`}</div>
			</div>
		);
	}
}

const s = StyleSheet.create({
	root: {
		flex: 1,
		fontSize: 14,
		whiteSpace: 'pre',
		padding: '20px 24px 0',
		boxSizing: 'border-box',
	},
});
